// Copyright Epic Games, Inc. All Rights Reserved.

export default {
  messages: {
    "error.errorCode": "Fehler-Code:",
    "error.search": "Suche in unserer Knowledge-Base, um mehr zu erfahren.",
    dismiss: "Schließen",
    "installation.title": "",
    "cancelation.button": "Abbrechen",
  },
  errorCodes: {
    "EOS-UI-NF": {
      title: "Initialisierung fehlgeschlagen",
      description:
        "Die Seite konnte nicht dargestellt werden. Bitte wende dich an den Support.",
    },
    "EOS-UI-UE": {
      title: "Da ist etwas schiefgelaufen.",
      description:
        "Da ist etwas schiefgelaufen. Bitte wende dich an den Support.",
    },
    "EOS-IN-BC": {
      title: "Installation fehlgeschlagen",
      description:
        "Der Installationsfortschritt konnte nicht angezeigt werden. Bitte wende dich an den Support.",
    },
    "EOS-IN-UE": {
      title: "Installation fehlgeschlagen",
      description:
        "Da ist etwas schiefgelaufen. Bitte wende dich an den Support.",
    },
    "EOS-IN-FF": {
      title: "Installation fehlgeschlagen",
      description:
        "Die Verbindung zu Epic Online Services konnte nicht hergestellt werden. Bitte wende dich an den Support.",
    },
    "EOS-IN-FF-*": {
      title: "Installation fehlgeschlagen",
      description:
        "Die Anfrage an Epic Online Services konnte nicht ausgeführt werden. Bitte wende dich an den Support.",
    },
    fallback: {
      title: "Da ist etwas schiefgelaufen.",
      description:
        "Da ist etwas schiefgelaufen. Bitte wende dich an den Support.",
    },
  },
};
